import React from "react";

export default function Footer(){ 
  return (
    <div className="footer silver">
                <span style={{fontSize: "13px"}}>© 2022 1313 Media, LLC. All rights reserved.</span>
    </div>
  );  
}